import en from './en.json'
import fr from './fr.json'
import es from './es.json'

export default { en, fr, es };